import gql from 'graphql-tag';
import actionTypes from './constants';

/* */
export const getCalendar = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_CALENDAR}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => ({ tournaments: data.getTournamentsCalendar }));

/* */
export const getTournament = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_TOURNAMENT}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => (data.getTournament));

/* */
export const getResults = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_RESULTS}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => ({ results: data.getTournamentResults }));

/* */
export const getStartList = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_STARTLIST}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => ({ startlist: data.getTournamentStartList }));

/* */
export const getEntryList = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_ENTRY_LIST}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => ({ entries: data.getTournamentEntryList }));

/* */
export const getMyTournaments = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_MY_TOURNAMENTS}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => data.getMyTournaments);
